import React from "react";


function TableHead() {


    return (

        <div className="players-list-container">
            <div className="header-row player-list-row">
                <div className="info-col">
                    Pos
                </div>
                <div className="info-col">
                    Name
                </div>
                <div className="info-col">
                    <span>Rating</span>
                    <span className="mobile-hide">R</span>
                </div>
                <div className="info-col">
                    Position
                </div>
                <div className="info-col">
                    <span>Games</span>
                    <span className="mobile-hide">G</span>
                </div>
                <div className="info-col">
                    <span>Goals</span>
                    <span className="mobile-hide">Gls</span>
                </div>
                <div className="info-col">
                    <span>Assists</span>
                    <span className="mobile-hide">A</span>
                </div>
                <div className="info-col">
                    Yellow
                </div>
                <div className="info-col">
                    Red
                </div>
            </div>
        </div>
    )
}

export {TableHead}
